import { compose, setDisplayName, mapProps } from 'recompose';
import classnames from 'classnames';
import React from 'react';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var addLunaClass = function addLunaClass(_ref) {
  var _classnames;

  var className = _ref.className,
      fixed = _ref.fixed,
      size = _ref.size,
      fillCurrent = _ref.fillCurrent,
      strokeCurrent = _ref.strokeCurrent,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "fixed", "size", "fillCurrent", "strokeCurrent"]);

  return Object.assign({}, props, {
    className: classnames(className, 'ln-c-icon', (_classnames = {
      'ln-c-icon--fixed': fixed
    }, _classnames["ln-c-icon--" + size] = size, _classnames['ln-c-icon--fill-current'] = fillCurrent, _classnames['ln-c-icon--stroke-current'] = strokeCurrent, _classnames))
  });
};

var iconHandler =
/* istanbul ignore next */
function iconHandler(Component) {
  return (
    /* istanbul ignore next */
    compose(setDisplayName(Component.displayName || Component.name || 'Icon'), mapProps(addLunaClass))(Component)
  );
};

var Accessibility = function Accessibility(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.146 9h2.704a1 1 0 0 1 0 2h-2.418l.285 2h3.133a1 1 0 0 1 .707.293l2 2a1 1 0 0 1-1.414 1.414L16.436 15H12.85a1 1 0 0 1-.99-.859l-1-7a1 1 0 1 1 1.98-.282L13.146 9zM11.35 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-2.715 6.58a1 1 0 1 1 .785 1.84 3.426 3.426 0 0 0-2.07 3.156C7.35 18.47 8.867 20 10.733 20c1.43 0 2.692-.906 3.177-2.244a1 1 0 0 1 1.88.683A5.386 5.386 0 0 1 10.733 22c-2.975 0-5.383-2.43-5.383-5.424a5.425 5.425 0 0 1 3.285-4.996z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Accessibility.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Accessibility$1 = iconHandler(Accessibility);

var Account = function Account(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 15c-3.632 0-7 1.894-7 4h14c0-2.106-3.368-4-7-4zm0-2c3.755 0 9 2.01 9 6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2c0-3.99 5.245-6 9-6zm0-4a1.999 1.999 0 1 0 0-4 1.999 1.999 0 1 0 0 4zm0 2c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Account.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Account$1 = iconHandler(Account);

var ArrowBottom = function ArrowBottom(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.586l6.293-6.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 1.414-1.414L12 11.586zM6 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm14 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM5 17h14v2H5v-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowBottom.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ArrowBottom$1 = iconHandler(ArrowBottom);

var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.586L5.707 8.293a1 1 0 0 0-1.414 1.414l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 1 0-1.414-1.414L12 14.586z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowDown.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ArrowDown$1 = iconHandler(ArrowDown);

var ArrowFirst = function ArrowFirst(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.414 12l6.293 6.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 1.414L12.414 12zM6 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM7 5v14H5V5h2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowFirst.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ArrowFirst$1 = iconHandler(ArrowFirst);

var ArrowLast = function ArrowLast(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.586 12l-6.293 6.293a1 1 0 0 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414l-7-7a1 1 0 0 0-1.414 1.414L11.586 12zM18 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM17 5v14h2V5h-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowLast.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ArrowLast$1 = iconHandler(ArrowLast);

var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.414 12l6.293-6.293a1 1 0 1 0-1.414-1.414l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414L9.414 12z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowLeft.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ArrowLeft$1 = iconHandler(ArrowLeft);

var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.293 18.293a1 1 0 0 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414l-7-7a1 1 0 0 0-1.414 1.414L14.586 12l-6.293 6.293z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowRight.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ArrowRight$1 = iconHandler(ArrowRight);

var ArrowTop = function ArrowTop(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.414l6.293 6.293a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 1.414 1.414L12 12.414zM6 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm14 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM5 7h14V5H5v2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowTop.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ArrowTop$1 = iconHandler(ArrowTop);

var ArrowUp = function ArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.414l6.293 6.293a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 1.414 1.414L12 9.414z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowUp.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ArrowUp$1 = iconHandler(ArrowUp);

var ArrowUpDown = function ArrowUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.11l4.72-4.924a.728.728 0 0 1 1.06 0 .807.807 0 0 1 0 1.107l-5.25 5.478a.728.728 0 0 1-1.06 0l-5.25-5.478a.807.807 0 0 1 0-1.107.728.728 0 0 1 1.06 0L12 19.11zm0-14.22L7.28 9.813a.728.728 0 0 1-1.06 0 .807.807 0 0 1 0-1.107l5.25-5.478a.728.728 0 0 1 1.06 0l5.25 5.478a.807.807 0 0 1 0 1.107.728.728 0 0 1-1.06 0L12 4.89z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowUpDown.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ArrowUpDown$1 = iconHandler(ArrowUpDown);

var AwardWinning = function AwardWinning(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.342 10.368V5.12c0-.005-2.802-.01-8.405-.015-.005 0-.01 1.755-.016 5.263-.048 3.171 1.973 5.264 4.21 5.264 2.134 0 4.213-2.098 4.211-5.264zm-4.21 7.369c-3.541 0-6.315-4.21-6.315-7.823V5.12c0-1.17.949-2.12 2.12-2.12h8.39c1.171 0 2.12.95 2.12 2.12v5.048c0 3.358-2.837 7.569-6.315 7.569zm-1.053 2.105v-3.158a1.053 1.053 0 0 1 2.105 0v3.158h2.105a1.053 1.053 0 1 1 0 2.105H8.974a1.053 1.053 0 1 1 0-2.105h2.105zm5.85-7.718a1.053 1.053 0 1 1 .931-1.888c.177.087.368.132.566.132.763 0 1.41-.692 1.41-1.579 0-.886-.647-1.578-1.41-1.578a1.053 1.053 0 0 1 0-2.106c1.958 0 3.516 1.665 3.516 3.684 0 2.02-1.558 3.685-3.516 3.685-.524 0-1.033-.12-1.497-.35zm-9.617 0c-.464.23-.972.35-1.496.35-1.958 0-3.516-1.665-3.516-3.685s1.558-3.684 3.516-3.684a1.053 1.053 0 0 1 0 2.106c-.763 0-1.41.692-1.41 1.578 0 .887.647 1.58 1.41 1.58.198 0 .389-.046.566-.133a1.053 1.053 0 1 1 .93 1.888z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

AwardWinning.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var AwardWinning$1 = iconHandler(AwardWinning);

var Bag = function Bag(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.718 9.5l1.4 8.166c.082.482.506.834 1.001.834h9.762c.495 0 .919-.352 1.001-.834l1.4-8.166H4.718zM8 7.5a4 4 0 1 1 8 0h4.484c.628 0 1.106.556 1.002 1.166L19.886 18c-.247 1.444-1.518 2.501-3.005 2.501H7.119c-1.487 0-2.758-1.057-3.005-2.501l-1.6-9.333A1.005 1.005 0 0 1 3.516 7.5H8zm2 0h4a2 2 0 1 0-4 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Bag.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Bag$1 = iconHandler(Bag);

var Basket = function Basket(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.006 10.03a1.003 1.003 0 0 0-.988 1.167l1.183 7c.08.48.498.833.987.833h9.624c.489 0 .907-.352.988-.833l1.183-7a.998.998 0 0 0-.988-1.167H6.005zm3.444-2h5.07l-1.463-3.658a1 1 0 0 1 1.857-.743l1.76 4.401h1.321a3.003 3.003 0 0 1 2.963 3.5l-1.183 7a3.004 3.004 0 0 1-2.963 2.5H7.188a3.004 3.004 0 0 1-2.963-2.5l-1.183-7a3 3 0 0 1 2.964-3.5h1.29l1.76-4.401a1 1 0 0 1 1.858.743L9.45 8.03z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Basket.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Basket$1 = iconHandler(Basket);

var Calendar = function Calendar(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.49 7c-.27 0-.49.238-.49.53v11.94c0 .292.22.53.49.53h13.02c.27 0 .49-.238.49-.53V7.53c0-.292-.22-.53-.49-.53H5.49zm0-2h13.02C19.885 5 21 6.184 21 7.646v11.708C21 20.816 19.885 22 18.51 22H5.49C4.115 22 3 20.816 3 19.354V7.646C3 6.184 4.115 5 5.49 5zm4.797 11.27l2.483-4.31H9.5a1 1 0 0 1 0-2h5a1 1 0 0 1 .867 1.5l-3.346 5.81a1 1 0 0 1-1.734-1zM8 3a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V3zm6.54.07a1 1 0 1 1 2 0v5a1 1 0 0 1-2 0v-5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Calendar.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Calendar$1 = iconHandler(Calendar);

var Cancel = function Cancel(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.487 12l5.205 5.205a1.052 1.052 0 0 1-1.487 1.487L12 13.487l-5.205 5.205a1.052 1.052 0 0 1-1.487-1.487L10.513 12 5.308 6.795a1.052 1.052 0 0 1 1.487-1.487L12 10.513l5.205-5.205a1.052 1.052 0 0 1 1.487 1.487L13.487 12z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Cancel.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Cancel$1 = iconHandler(Cancel);

var ClickAndColleck = function ClickAndColleck(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.344 8h5.342l-1.142-3.705a1 1 0 1 1 1.912-.59L16.779 8h1.217a3.002 3.002 0 0 1 2.962 3.5l-.206 1.222a1 1 0 0 1-1.972-.333l.206-1.223a1.002 1.002 0 0 0-.99-1.166H6.004a1 1 0 0 0-.99 1.166l1.184 7c.08.481.499.834.99.834h5.583a1 1 0 0 1 0 2H7.187a3.003 3.003 0 0 1-2.962-2.5l-1.183-7A3 3 0 0 1 6.004 8h1.252l1.286-4.287a1 1 0 0 1 1.916.575L9.344 8zm9.418 9.348l1.945 1.945a1 1 0 0 1-1.414 1.414l-1.915-1.914-.098.185a1.014 1.014 0 0 1-1.87-.195l-.883-3.044a1.014 1.014 0 0 1 1.265-1.255l2.954.884a1.014 1.014 0 0 1 .213 1.853l-.164.093-.033.034z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

ClickAndColleck.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ClickAndCollect = iconHandler(ClickAndColleck);

var Comment = function Comment(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 16h5.68A1.32 1.32 0 0 0 19 14.68V7.32A1.32 1.32 0 0 0 17.68 6H6.32A1.32 1.32 0 0 0 5 7.32v7.36c0 .729.591 1.32 1.32 1.32H8l2 2.667L12 16zm5.68-12A3.32 3.32 0 0 1 21 7.32v7.36A3.32 3.32 0 0 1 17.68 18H13l-3 4-3-4h-.68A3.32 3.32 0 0 1 3 14.68V7.32A3.32 3.32 0 0 1 6.32 4h11.36zM8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Comment.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Comment$1 = iconHandler(Comment);

var Delete = function Delete(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 6l.001-1.51h.147a3.49 3.49 0 0 1 3.342-2.488L12.505 2a3.49 3.49 0 0 1 3.49 3.49v.065L15.987 6H20a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2h4zm2.002 0h3.984v-.019l.01-.463V5.49A1.49 1.49 0 0 0 12.506 4l-1.015.002a1.49 1.49 0 0 0-1.49 1.489V6zM8.5 11a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6zm5 0a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0v-6zm-9.447-.008a1 1 0 1 1 2 .016l-.055 7.094A1.886 1.886 0 0 0 7.88 20h8.237c1.04 0 1.883-.843 1.883-1.892l-.032-7.103a1 1 0 1 1 2-.01l.032 7.122A3.883 3.883 0 0 1 16.118 22H7.851a3.883 3.883 0 0 1-3.853-3.913l.055-7.095z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Delete.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Delete$1 = iconHandler(Delete);

var Delivery = function Delivery(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19.647 11.985L16.12 8.444a.952.952 0 0 1 1.349-1.345l4.084 4.098v2.427a2.709 2.709 0 0 1-2.71 2.71H5.21a2.709 2.709 0 0 1-2.709-2.71V5.71A2.709 2.709 0 0 1 5.209 3h6.956a2.709 2.709 0 0 1 2.71 2.709v5.882a.952.952 0 1 1-1.905 0V5.709a.804.804 0 0 0-.805-.804H5.21a.804.804 0 0 0-.804.804v7.915c0 .445.36.805.804.805h13.634c.444 0 .804-.36.804-.805v-1.64zm-2.861 9.11a1.905 1.905 0 1 1 0-3.81 1.905 1.905 0 0 1 0 3.81zm-9.524 0a1.905 1.905 0 1 1 0-3.81 1.905 1.905 0 0 1 0 3.81z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Delivery.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Delivery$1 = iconHandler(Delivery);

var Dislike = function Dislike(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.574 14a.074.074 0 0 1-.074-.074V6.075c0-.041.033-.074.074-.074H6.5v8H4.574zm0 2H8.5V4H4.574A2.074 2.074 0 0 0 2.5 6.076v7.851c0 1.146.929 2.075 2.074 2.075zM8.5 14.674V6.037c3.266-1.008 6.03-1.276 8.292-.825 1.512.302 2.244.855 2.537 1.605.152.385.184.755.165 1.406-.005.196-.006.231-.006.313v5.465c0 .378-.716 1-1.339 1H13.5a1 1 0 0 0-1 .998l-.005 3.583a.074.074 0 0 1-.052.07l-.985.305a.943.943 0 0 1-1.16-.565L8.5 14.673zm9.65 2.328c1.668 0 3.338-1.45 3.338-3V8.536c0-.053 0-.085.005-.254.027-.903-.025-1.49-.301-2.195-.557-1.421-1.862-2.408-4.01-2.836-2.797-.558-6.128-.18-9.998 1.108a1 1 0 0 0-.684.949v9.55a1 1 0 0 0 .066.356l1.864 4.89a2.943 2.943 0 0 0 3.619 1.764l.985-.304a2.074 2.074 0 0 0 1.461-1.98l.004-2.583h3.65z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Dislike.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Dislike$1 = iconHandler(Dislike);

var Download = function Download(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 13.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L11 13.586V4a1 1 0 0 1 2 0v9.586zM5 21a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2H5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Download.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Download$1 = iconHandler(Download);

var Edit = function Edit(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.422 7.405l-9.908 10.26v1.948h2.21l9.85-10.057-2.152-2.15zm1.39-1.439l2.16 2.161 1.522-1.553-2.209-2.133-1.473 1.525zM2.5 16.872L16.083 2.807a1.66 1.66 0 0 1 2.347-.041l2.698 2.606a1.66 1.66 0 0 1 .041 2.347L7.587 21.613H2.5v-4.74z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Edit.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Edit$1 = iconHandler(Edit);

var ErrorCircle = function ErrorCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1.376-14.168c0 .048-.016.096-.016.144l-.896 5.808h-.928l-.896-5.808c0-.048-.016-.096-.016-.144 0-.72.72-1.152 1.376-1.152.656 0 1.376.432 1.376 1.152zm-.112 8.048c0 .704-.56 1.264-1.264 1.264s-1.264-.56-1.264-1.264.56-1.264 1.264-1.264 1.264.56 1.264 1.264z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

ErrorCircle.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ErrorCircle$1 = iconHandler(ErrorCircle);

var Favourites = function Favourites(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.04l-1.992-2.002a3.502 3.502 0 0 0-4.975-.003 3.579 3.579 0 0 0 .003 5.034l6.842 6.88a.17.17 0 0 0 .243 0l6.842-6.88a3.576 3.576 0 0 0 .003-5.034 3.505 3.505 0 0 0-4.975.003l-1.992 2.003zm0-2.836l.759-.755a5.505 5.505 0 0 1 7.625.176 5.576 5.576 0 0 1-.003 7.855l-6.842 6.88a2.17 2.17 0 0 1-3.08 0l-6.841-6.88a5.579 5.579 0 0 1-.003-7.855 5.502 5.502 0 0 1 7.625-.176l.76.755z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Favourites.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Favourites$1 = iconHandler(Favourites);

var FavouritesFilled = function FavouritesFilled(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.204l.759-.755a5.505 5.505 0 0 1 7.625.176 5.576 5.576 0 0 1-.003 7.855l-6.842 6.88a2.17 2.17 0 0 1-3.08 0l-6.841-6.88a5.579 5.579 0 0 1-.003-7.855 5.502 5.502 0 0 1 7.625-.176l.76.755z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

FavouritesFilled.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var FavouritesFilled$1 = iconHandler(FavouritesFilled);

var Geolocation = function Geolocation(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm6.93-4.002a7.007 7.007 0 0 1-5.442 5.844c.008.051.012.104.012.158v2a1 1 0 0 1-2 0v-2-.018a7.003 7.003 0 0 1-6.43-5.984A1.015 1.015 0 0 1 5 13H3a1 1 0 0 1 0-2h2c.024 0 .047 0 .07.002a7.004 7.004 0 0 1 5.932-5.931A1.015 1.015 0 0 1 11 5V3a1 1 0 0 1 2 0v2c0 .024 0 .047-.002.07a7.004 7.004 0 0 1 5.931 5.932L19 11h2a1 1 0 0 1 0 2h-2c-.024 0-.047 0-.07-.002zM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Geolocation.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Geolocation$1 = iconHandler(Geolocation);

var GridView = function GridView(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 4h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm6 0h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm6 0h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM5 10h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm6 0h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm6 0h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zM5 16h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm6 0h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm6 0h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

GridView.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var GridView$1 = iconHandler(GridView);

var Home = function Home(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.045C9 14.395 10.176 13 12 13s3 1.39 3 3.045V19h1.995c.562 0 1.005-.438 1.005-.971v-6.94c0-.267-.212-.772-.41-.968l-4.874-4.828a1.023 1.023 0 0 0-1.432 0L6.41 10.12c-.2.198-.41.697-.41.968v6.94c0 .535.441.971 1.005.971H9v-2.955zM7.005 21C5.344 21 4 19.676 4 18.029v-6.94c0-.807.424-1.817 1.003-2.39l4.873-4.827a3.023 3.023 0 0 1 4.248 0L18.997 8.7c.577.57 1.003 1.588 1.003 2.39v6.939C20 19.67 18.657 21 16.995 21H13v-4.955c0-.55-.303-1.045-1-1.045-.697 0-1 .501-1 1.045V21H7.005z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Home.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Home$1 = iconHandler(Home);

var Info = function Info(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 18h3v-7H8a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1v9l-1-1h4c1.333 0 1.333 2 0 2H8a1 1 0 0 1 0-2zm4-11a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Info.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Info$1 = iconHandler(Info);

var InfoCircle = function InfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1.54-14.872c0 .656-.496 1.184-1.152 1.184-.656 0-1.2-.528-1.2-1.184 0-.656.528-1.184 1.184-1.184.656 0 1.168.528 1.168 1.184zm-2.176 3.616h-.928V9.24h2.56c.368 0 .496.176.496.512v5.456c0 .336.128.48.384.48.192 0 .48-.112.608-.208l-.064 1.216c-.304.208-.832.4-1.408.4-.656 0-1.104-.192-1.36-.544-.208-.288-.288-.736-.288-1.248v-4.56z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

InfoCircle.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var InfoCircle$1 = iconHandler(InfoCircle);

var LandlinePhone = function LandlinePhone(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.89 19.084s-1.61-1.562-3.368-4.609c1.57 2.719 3.369 4.609 3.369 4.609 1.095 1.189 2.808 1.674 4.766.543l2.243-1.294a.952.952 0 0 0 .338-1.296l-1.373-2.38a.955.955 0 0 0-1.303-.346l-2.612 1.508s-.734-.406-2.304-3.125c-1.569-2.717-1.544-3.539-1.544-3.539l2.613-1.508a.956.956 0 0 0 .35-1.303L11.69 3.965A.952.952 0 0 0 10.4 3.61L8.157 4.905c-1.958 1.13-2.394 2.857-1.912 4.4 0 0 .707 2.452 2.277 5.17-1.76-3.046-2.277-5.17-2.277-5.17",
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

LandlinePhone.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var LandlinePhone$1 = iconHandler(LandlinePhone);

var Like = function Like(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.574 10a.074.074 0 0 0-.074.074v7.851c0 .041.033.074.074.074H6.5v-8H4.574zm0-2H8.5v12H4.574A2.074 2.074 0 0 1 2.5 17.924v-7.851c0-1.146.929-2.075 2.074-2.075zM8.5 9.326v8.636c3.266 1.008 6.03 1.276 8.292.825 1.512-.302 2.244-.855 2.537-1.605.152-.385.184-.755.165-1.406a9.029 9.029 0 0 1-.006-.313V9.999c0-.378-.716-1-1.339-1H13.5a1 1 0 0 1-1-.998l-.005-3.583a.074.074 0 0 0-.052-.07l-.985-.305a.943.943 0 0 0-1.16.565L8.5 9.327zm9.65-2.328c1.668 0 3.338 1.45 3.338 3v5.465c0 .053 0 .085.005.254.027.903-.025 1.49-.301 2.195-.557 1.421-1.862 2.408-4.01 2.836-2.797.558-6.128.18-9.998-1.108a1 1 0 0 1-.684-.949v-9.55a1 1 0 0 1 .066-.356l1.864-4.89a2.943 2.943 0 0 1 3.619-1.764l.985.304a2.074 2.074 0 0 1 1.461 1.98l.004 2.583h3.65z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Like.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Like$1 = iconHandler(Like);

var List = function List(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H8zm0-2h8a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm6 5a1 1 0 0 1 0 2h-4a1 1 0 1 1 0-2h4zm0 3a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2h4zm0 3a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2h4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

List.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var List$1 = iconHandler(List);

var ListView = function ListView(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm0 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm0 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm7-11a1 1 0 0 1 0-2h7a1 1 0 1 1 0 2h-7zm0 6a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2h-7zm0 6a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2h-7z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

ListView.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ListView$1 = iconHandler(ListView);

var Measurement = function Measurement(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.18 5.28l-9.9 9.9 3.535 3.535 9.9-9.9-3.536-3.535zm.706-2.122l4.95 4.95a1 1 0 0 1 0 1.414L9.522 20.836a1 1 0 0 1-1.414 0l-4.95-4.95a1 1 0 0 1 0-1.414L14.472 3.158a1 1 0 0 1 1.414 0zM6.158 13.573a1 1 0 0 1 1.415-1.415l2 2a1 1 0 1 1-1.415 1.415l-2-2zm3-3a1 1 0 0 1 1.415-1.415l1 1a1 1 0 0 1-1.415 1.415l-1-1zm3-3a1 1 0 1 1 1.415-1.415l2 2a1 1 0 1 1-1.415 1.415l-2-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Measurement.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Measurement$1 = iconHandler(Measurement);

var Menu = function Menu(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.067 18C4.477 18 4 17.552 4 17s.478-1 1.067-1h13.866c.59 0 1.067.448 1.067 1s-.478 1-1.067 1H5.067zm0-5C4.477 13 4 12.552 4 12s.478-1 1.067-1h13.866c.59 0 1.067.448 1.067 1s-.478 1-1.067 1H5.067zm0-5C4.477 8 4 7.552 4 7s.478-1 1.067-1h13.866C19.523 6 20 6.448 20 7s-.478 1-1.067 1H5.067z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Menu.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Menu$1 = iconHandler(Menu);

var Messages = function Messages(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.43 6.5l4.818 4.72c.418.41 1.086.41 1.504 0l4.819-4.72H6.429zM19 7.9l-4.848 4.749a3.075 3.075 0 0 1-4.304 0L5 7.899v8.526c0 .594.481 1.075 1.075 1.075h11.85c.594 0 1.075-.481 1.075-1.075V7.9zM6.075 4.5h11.85A3.075 3.075 0 0 1 21 7.575v8.85a3.075 3.075 0 0 1-3.075 3.075H6.075A3.075 3.075 0 0 1 3 16.425v-8.85A3.075 3.075 0 0 1 6.075 4.5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Messages.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Messages$1 = iconHandler(Messages);

var Minus = function Minus(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 13h14a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Minus.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Minus$1 = iconHandler(Minus);

var MobilePhone = function MobilePhone(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.83 5a.83.83 0 0 0-.83.83v12.34c0 .458.372.83.83.83h6.34a.83.83 0 0 0 .83-.83V5.83a.83.83 0 0 0-.83-.83H8.83zm0-2h6.34A2.83 2.83 0 0 1 18 5.83v12.34A2.83 2.83 0 0 1 15.17 21H8.83A2.83 2.83 0 0 1 6 18.17V5.83A2.83 2.83 0 0 1 8.83 3zM7 8V6h10v2H7zm0 10v-2h10v2H7z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

MobilePhone.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var MobilePhone$1 = iconHandler(MobilePhone);

var More = function More(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

More.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var More$1 = iconHandler(More);

var NewWindow = function NewWindow(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 6.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L17.586 5H15a1 1 0 0 1 0-2h5a.997.997 0 0 1 1 1v5a1 1 0 0 1-2 0V6.414zm-2 7.409a1 1 0 0 1 2 0V16a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h2.208a1 1 0 0 1 0 2H8a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-2.177z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

NewWindow.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var NewWindow$1 = iconHandler(NewWindow);

var Nfc = function Nfc(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.72 15.016a.823.823 0 0 1-1.143.302.869.869 0 0 1-.294-1.173 3.519 3.519 0 0 0 .477-1.772c0-.723-.216-1.422-.613-2.012a.87.87 0 0 1 .214-1.19c.38-.27.9-.171 1.161.218a5.35 5.35 0 0 1 .907 2.984c0 .94-.246 1.837-.709 2.643zm2.711 1.583a.823.823 0 0 1-1.149.278.87.87 0 0 1-.271-1.178c.564-.937.877-2.093.877-3.326 0-1.345-.373-2.615-1.025-3.578a.87.87 0 0 1 .21-1.192.822.822 0 0 1 1.162.216c.849 1.255 1.323 2.866 1.323 4.554 0 1.547-.398 3.016-1.127 4.226zm2.33 1.685a.82.82 0 0 1-1.176.096.872.872 0 0 1-.093-1.207c.95-1.143 1.526-2.893 1.526-4.8 0-2.048-.665-3.917-1.728-5.037a.872.872 0 0 1 .016-1.211.82.82 0 0 1 1.18.016c1.382 1.457 2.202 3.758 2.202 6.232 0 2.299-.707 4.445-1.926 5.911zm2.795 1.415a.82.82 0 0 1-1.176.096.872.872 0 0 1-.094-1.207c1.276-1.535 2.045-3.87 2.045-6.407 0-2.726-.889-5.22-2.318-6.727a.872.872 0 0 1 .016-1.211.82.82 0 0 1 1.18.016C16.959 6.103 18 9.03 18 12.181c0 2.93-.9 5.66-2.444 7.518z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Nfc.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Nfc$1 = iconHandler(Nfc);

var Notification = function Notification(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.998 4.587c2.5.454 4.4 2.62 4.4 5.226 0 2.355.446 4.171 1.179 5.524.415.767.804 1.199 1.016 1.356.775.574.37 1.803-.595 1.803h-3.032a4 4 0 0 1-7.936 0H5.002c-.968 0-1.371-1.237-.59-1.807.217-.158.613-.591 1.034-1.357.743-1.352 1.197-3.167 1.197-5.519 0-2.591 1.877-4.746 4.355-5.218V3a1 1 0 1 1 2 0v1.587zm.937 13.909h-3.873a2 2 0 0 0 3.873 0zm2.884-2.207c-.893-1.65-1.421-3.793-1.421-6.476 0-1.826-1.51-3.314-3.378-3.314S8.643 7.987 8.643 9.813c0 2.685-.537 4.831-1.445 6.482a9.81 9.81 0 0 1-.113.202h9.849a9.836 9.836 0 0 1-.115-.208z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Notification.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Notification$1 = iconHandler(Notification);

var OverflowMenu = function OverflowMenu(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(90 12 6)",
    cx: "12",
    cy: "6",
    r: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(90 12 12)",
    cx: "12",
    cy: "12",
    r: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(90 12 18)",
    cx: "12",
    cy: "18",
    r: "2"
  })));
};

OverflowMenu.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var OverflowMenu$1 = iconHandler(OverflowMenu);

var Plus = function Plus(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 11V5a1 1 0 0 1 2 0v6h6a1 1 0 0 1 0 2h-6v6a1 1 0 0 1-2 0v-6H5a1 1 0 0 1 0-2h6z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Plus.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Plus$1 = iconHandler(Plus);

var Print = function Print(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.961 6C9.431 6 9 6.43 9 6.961V9h6V6.961c0-.53-.43-.961-.961-.961H9.96zM17 9h1.122c1.542 0 2.855 1.374 2.855 2.815L21 15.73a1 1 0 0 1-1.003 1.006l-.936-.002.003.365c0 1.156-.669 1.916-1.9 1.9H6.821c-1.206.016-1.88-.801-1.88-1.888l-.004-.377-.924.002a1 1 0 0 1-1.002-.997L3 11.82C3 10.378 4.363 9 5.904 9H7V6.961A2.961 2.961 0 0 1 9.961 4h4.078A2.961 2.961 0 0 1 17 6.961V9zm.06 7.58l-.002-.254a96.985 96.985 0 0 1-.003-.594 1 1 0 0 1 1.003-1l.936.002-.017-2.913c0-.362-.438-.821-.855-.821H5.904c-.432 0-.904.477-.904.818l.008 2.916.921-.002a1 1 0 0 1 1.003 1A106.783 106.783 0 0 0 6.94 17h10.124l-.003-.42zM16 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

Print.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Print$1 = iconHandler(Print);

var Scan = function Scan(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 9a1 1 0 1 1 2 0v6a1 1 0 0 1-2 0V9zm3.5 0a1 1 0 1 1 2 0v6a1 1 0 0 1-2 0V9zm3.25 0a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0V9zM16 9a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0V9zM4.5 6v2a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-2zm2 12a1 1 0 0 1 0 2h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v2h2zm13-12h-2a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V6zm-2 12h2v-2a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 0 1 0-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Scan.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Scan$1 = iconHandler(Scan);

var Search = function Search(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.692 15.333a5.641 5.641 0 1 0 0-11.282 5.641 5.641 0 0 0 0 11.282zm6.117-.975l5.89 5.891a1.026 1.026 0 0 1-1.45 1.45l-5.89-5.89a7.692 7.692 0 1 1 1.45-1.45z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Search.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Search$1 = iconHandler(Search);

var Settings = function Settings(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.653 6.039A1 1 0 0 1 9.986 7a5.79 5.79 0 0 0-1.769 1 1 1 0 0 1-1.1.115l-1.895-.993-1.156 1.97 1.787.936a1 1 0 0 1 .52 1.065 5.03 5.03 0 0 0 .036 1.991 1 1 0 0 1-.482 1.085l-1.748.993 1.23 1.933 1.856-1.055a1 1 0 0 1 1.104.078 5.824 5.824 0 0 0 1.806.941 1 1 0 0 1 .699.935l.037 2.004 2.473-.04-.037-2a1 1 0 0 1 .667-.962 5.79 5.79 0 0 0 1.769-1 1 1 0 0 1 1.1-.115l1.895.993 1.156-1.97-1.787-.936a1 1 0 0 1-.52-1.065 5.03 5.03 0 0 0-.036-1.991 1 1 0 0 1 .482-1.085l1.748-.993-1.23-1.933-1.856 1.055a1 1 0 0 1-1.104-.078 5.824 5.824 0 0 0-1.806-.941 1 1 0 0 1-.699-.935l-.036-1.947c0-.018-.043-.056-.132-.055l-2.342.039.037 2zM8.614 3.905a1.83 1.83 0 0 1 1.795-1.863L12.925 2c1.161-.019 2.143.865 2.164 2.018l.023 1.263c.414.175.81.383 1.186.623l1.448-.822a1.829 1.829 0 0 1 2.446.61l1.411 2.22a1.83 1.83 0 0 1-.561 2.526l-.079.047-1.298.737a7.074 7.074 0 0 1 .024 1.296l1.33.697a1.83 1.83 0 0 1 .772 2.47c-.02.04-.02.04-.043.077l-1.327 2.264a1.829 1.829 0 0 1-2.426.695l-1.478-.775a7.789 7.789 0 0 1-1.159.66l.028 1.485a1.83 1.83 0 0 1-1.795 1.863l-2.817.047a1.83 1.83 0 0 1-1.859-1.796l-.027-1.49a7.823 7.823 0 0 1-1.186-.623l-1.448.822a1.829 1.829 0 0 1-2.446-.61l-1.411-2.22a1.83 1.83 0 0 1 .561-2.526l.079-.047 1.298-.737a7.074 7.074 0 0 1-.024-1.296l-1.33-.697a1.83 1.83 0 0 1-.772-2.47c.02-.04.02-.04.043-.077L3.579 5.97a1.829 1.829 0 0 1 2.426-.696l1.478.775a7.789 7.789 0 0 1 1.159-.66l-.028-1.485zM12 16a4 4 0 0 1-3.998-4A4 4 0 1 1 12 16zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Settings.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Settings$1 = iconHandler(Settings);

var StoreLocation = function StoreLocation(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.354 21.48a2.014 2.014 0 0 1-2.846-.138C6.186 16.58 4 12.847 4 10c0-4.513 3.536-8 8-8s8 3.487 8 8c0 2.847-2.186 6.58-6.508 11.342-.044.049-.09.095-.138.138zM18 10c0-3.402-2.634-6-6-6s-6 2.598-6 6c0 2.2 1.98 5.58 5.99 9.998C16.02 15.58 18 12.2 18 10zm-6 3a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

StoreLocation.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var StoreLocation$1 = iconHandler(StoreLocation);

var StoreLocation1 = function StoreLocation1(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.354 21.48a2.014 2.014 0 0 1-2.846-.138C6.186 16.58 4 12.847 4 10c0-4.513 3.536-8 8-8s8 3.487 8 8c0 2.847-2.186 6.58-6.508 11.342-.044.049-.09.095-.138.138zM18 10c0-3.402-2.634-6-6-6s-6 2.598-6 6c0 2.2 1.98 5.58 5.99 9.998C16.02 15.58 18 12.2 18 10zm-6.008-2.304h.796c.158 0 .208.034.208.183v4.175h.78V13h-3.08v-.946h.856V9.157l-.581.34c-.1.059-.175.05-.224-.041l-.432-.747 1.677-1.013z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

StoreLocation1.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var StoreLocation1$1 = iconHandler(StoreLocation1);

var StoreLocation10 = function StoreLocation10(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.354 21.48a2.014 2.014 0 0 1-2.846-.138C6.186 16.58 4 12.847 4 10c0-4.513 3.536-8 8-8s8 3.487 8 8c0 2.847-2.186 6.58-6.508 11.342-.044.049-.09.095-.138.138zM18 10c0-3.402-2.634-6-6-6s-6 2.598-6 6c0 2.2 1.98 5.58 5.99 9.998C16.02 15.58 18 12.2 18 10zM9.677 7.696h.796c.158 0 .208.034.208.183v4.175h.78V13h-3.08v-.946h.856V9.157l-.581.34c-.1.059-.175.05-.224-.041L8 8.709l1.677-1.013zm6.357 2.681c0 1.644-.622 2.723-2.116 2.723-1.494 0-2.133-1.08-2.133-2.723 0-1.643.63-2.73 2.125-2.73 1.494 0 2.124 1.087 2.124 2.73zm-1.51 0c0-1.195-.166-1.643-.614-1.643-.449 0-.615.448-.615 1.643s.175 1.635.623 1.635.606-.44.606-1.635z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

StoreLocation10.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var StoreLocation10$1 = iconHandler(StoreLocation10);

var Tick = function Tick(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.29 15.19l3.13 3.162a2.328 2.328 0 0 0 3.5-.217L19.791 6.61a1 1 0 1 0-1.584-1.22L9.335 16.915c-.158.16-.366.16-.493.03L5.71 13.782a1 1 0 1 0-1.422 1.407z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Tick.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Tick$1 = iconHandler(Tick);

var Time = function Time(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm1-13a1 1 0 0 0-2 0v5.065l4.052 3.039a1 1 0 0 0 1.2-1.6L13 12.065V8z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Time.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Time$1 = iconHandler(Time);

var Trolley = function Trolley(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.1 7.713L7.58 14.2c.106.468.523.8 1.003.8h8.436c.48 0 .896-.332 1.003-.8l.911-3.988a2.043 2.043 0 0 0-1.992-2.499H6.101zm0 0H4.843a1 1 0 0 1 0-2h12.1a4.043 4.043 0 0 1 3.94 4.944l-.91 3.99A3.029 3.029 0 0 1 17.018 17H8.583a3.029 3.029 0 0 1-2.953-2.355L3.025 3.223a1 1 0 0 1 1.95-.445l1.126 4.935zM17 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-8 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Trolley.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Trolley$1 = iconHandler(Trolley);

var Upload = function Upload(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 10.414l3.293 3.293a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L11 10.414V20a1 1 0 0 0 2 0v-9.586zM5 3a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2H5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Upload.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var Upload$1 = iconHandler(Upload);

var VoiceSearch = function VoiceSearch(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 4a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 3 0v-5A1.5 1.5 0 0 0 12 4zm-.91 15.5v-2.05C7.68 17.07 5 14.588 5 11.5a1 1 0 0 1 2 0c0 2.165 2.202 4 5 4s5-1.835 5-4a1 1 0 0 1 2 0c0 3.033-2.587 5.482-5.91 5.928V19.5h1.41a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2h1.59zM12 2a3.5 3.5 0 0 1 3.5 3.5v5a3.5 3.5 0 0 1-7 0v-5A3.5 3.5 0 0 1 12 2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

VoiceSearch.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var VoiceSearch$1 = iconHandler(VoiceSearch);

var ZoomIn = function ZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.358 15.809a7.692 7.692 0 1 1 1.45-1.45l5.892 5.89a1.026 1.026 0 0 1-1.45 1.45l-5.892-5.89zm-4.666-.476a5.641 5.641 0 1 0 0-11.282 5.641 5.641 0 0 0 0 11.282zm-2.564-4.615h5.128a1.026 1.026 0 1 0 0-2.051H7.128a1.026 1.026 0 1 0 0 2.05zm1.539-3.59v5.128a1.026 1.026 0 0 0 2.05 0V7.128a1.026 1.026 0 1 0-2.05 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ZoomIn.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ZoomIn$1 = iconHandler(ZoomIn);

var ZoomOut = function ZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.358 15.809a7.692 7.692 0 1 1 1.45-1.45l5.892 5.89a1.026 1.026 0 0 1-1.45 1.45l-5.892-5.89zm-4.666-.476a5.641 5.641 0 1 0 0-11.282 5.641 5.641 0 0 0 0 11.282zm-2.564-4.615h5.128a1.026 1.026 0 1 0 0-2.051H7.128a1.026 1.026 0 1 0 0 2.05z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ZoomOut.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
var ZoomOut$1 = iconHandler(ZoomOut);
export { Accessibility$1 as Accessibility, Account$1 as Account, ArrowBottom$1 as ArrowBottom, ArrowDown$1 as ArrowDown, ArrowFirst$1 as ArrowFirst, ArrowLast$1 as ArrowLast, ArrowLeft$1 as ArrowLeft, ArrowRight$1 as ArrowRight, ArrowTop$1 as ArrowTop, ArrowUp$1 as ArrowUp, ArrowUpDown$1 as ArrowUpDown, AwardWinning$1 as AwardWinning, Bag$1 as Bag, Basket$1 as Basket, Calendar$1 as Calendar, Cancel$1 as Cancel, ClickAndCollect, Comment$1 as Comment, Delete$1 as Delete, Delivery$1 as Delivery, Dislike$1 as Dislike, Download$1 as Download, Edit$1 as Edit, ErrorCircle$1 as ErrorCircle, Favourites$1 as Favourites, FavouritesFilled$1 as FavouritesFilled, Geolocation$1 as Geolocation, GridView$1 as GridView, Home$1 as Home, Info$1 as Info, InfoCircle$1 as InfoCircle, LandlinePhone$1 as LandlinePhone, Like$1 as Like, List$1 as List, ListView$1 as ListView, Measurement$1 as Measurement, Menu$1 as Menu, Messages$1 as Messages, Minus$1 as Minus, MobilePhone$1 as MobilePhone, More$1 as More, NewWindow$1 as NewWindow, Nfc$1 as Nfc, Notification$1 as Notification, OverflowMenu$1 as OverflowMenu, Plus$1 as Plus, Print$1 as Print, Scan$1 as Scan, Search$1 as Search, Settings$1 as Settings, StoreLocation$1 as StoreLocation, StoreLocation1$1 as StoreLocation1, StoreLocation10$1 as StoreLocation10, Tick$1 as Tick, Time$1 as Time, Trolley$1 as Trolley, Upload$1 as Upload, VoiceSearch$1 as VoiceSearch, ZoomIn$1 as ZoomIn, ZoomOut$1 as ZoomOut };